import {
  DELETE_ITEM_REQUEST,
  DELETE_ITEM_SUCCESS,
  DELETE_ITEM_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: {},
    error: false,
  };
};

const initialState = getInitialState();

const deleteItem = (state = initialState, action) => {
  const types = {
    [DELETE_ITEM_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [DELETE_ITEM_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
    }),
    [DELETE_ITEM_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default deleteItem;
